import { useEffect, useRef, useState } from "react";
import CreateButton from "../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton";
import EditButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton";
import DeleteButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton";
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import Modal from "../../../../Partials/Elements/Modal/Modal";
import DeleteItem from "../../../../Partials/Layouts/DeleteItem/DeleteItem";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import { BLOGS_API } from "../../../../../Utilities/APIs/APIs";

import CreateBlog from "./CreateBlog";
import UpdateBlog from "./updateBlog";
import ViewBlog from "./ViewBlog";

function Blogs() {
  const axiosInstance = useAxiosInstance();

  const [blogs, setBlogs] = useState(null);
  const screenHeaerRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);

  const [toggleFetch, setToggleFetch] = useState(false);
  const [targetID, setTargetID] = useState(null);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight);
  }, [screenHeaerRef]);

  useEffect(() => {
    async function fetchAndSetBlogs() {
      const { data } = await axiosInstance.get(BLOGS_API);
      setBlogs(data);
    }

    fetchAndSetBlogs();
  }, [toggleFetch, axiosInstance]);

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <h1 className="screen_heading">
          Blogs ({blogs?.length} in total)
        </h1>

        <CreateButton
          screenTopicSingular={"Blog"}
          setShowCreateForm={setShowCreateForm}
        />
      </div>

      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th="Title" />
          <CRUDth th="Category" />
          <CRUDth th="Slug" />
          <CRUDth th="Visibility" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>

        <tbody>
          {blogs?.map((blog) => (
            <CRUDTableRow key={blog._id}>
              <ShortTextCell text={blog.title} />
              <ShortTextCell text={blog.category} />
              <ShortTextCell text={blog.slug} />
              <ShortTextCell text={blog.isVisible ? "True" : "False"} />

              <td>
                <div className="action_buttons_wrapper">
                  <div className="action_buttons">
                    <ViewButton
                      setShowViewSection={setShowViewSection}
                      targetID={blog._id}
                      setTargetID={setTargetID}
                      tooltipName={"View"}
                      tooltipContent={"View"}
                    />

                    <EditButton
                      setShowUpdateForm={setShowUpdateForm}
                      targetID={blog._id}
                      setTargetID={setTargetID}
                      tooltipName={"Edit"}
                      tooltipContent={"Edit"}
                    />

                    <DeleteButton
                      setShowDeleteSection={setShowDeleteSection}
                      targetID={blog._id}
                      setTargetID={setTargetID}
                    />
                  </div>
                </div>
              </td>
            </CRUDTableRow>
          ))}
        </tbody>
      </CRUDTable>

      {showCreateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={"Add Blog"}
          setShowModalContent={setShowCreateForm}
        >
          <CreateBlog
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
      )}

      {showUpdateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={"Update Blog"}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateBlog
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      )}

      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={"View Blog"}
          setShowModalContent={setShowViewSection}
        >
          <ViewBlog targetID={targetID} />
        </Modal>
      )}

      {showDeleteSection && (
        <Modal
          extraClass={"small"}
          modalHeading={"Delete Blog"}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={BLOGS_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      )}
    </>
  );
}

export default Blogs;